import Jet from './jet.js'
window.jetjs = new Jet()
